import React from 'react';
import './GameBoard.css';

function GameBoard({ gameState, playerId, isOwnBoard, selectedCells, onCellClick, showAllShips = false }) {
  const player = gameState.players[playerId];
  const opponentId = gameState.host === playerId ? gameState.guest : gameState.host;
  const opponent = opponentId ? gameState.players[opponentId] : null;

  const renderCell = (row, col) => {
    const cell = `${String.fromCharCode(64 + col)}${row}`;
    const isSelected = selectedCells.includes(cell);

    let className = 'grid-cell';
    let content = '';

    if (isOwnBoard) {
      const hasShip = Object.values(player.ships).flat().includes(cell);
      const isHit = opponent && opponent.hits.includes(cell);
      const isMiss = opponent && opponent.attacks.includes(cell) && !opponent.hits.includes(cell);

      if (isSelected) className += ' selected';
      if (hasShip) className += ' ship';
      if (isHit) className += ' hit';
      if (isMiss) className += ' miss';

      // During placement, all cells are available
      if (gameState.phase === 'placement') {
        className += ' available';
      }
    } else {
      const isAttacked = player.attacks.includes(cell);
      const isHit = player.hits.includes(cell);
      const isMiss = isAttacked && !isHit;
      // Check if opponent has a ship here (for revealing at end)
      const opponentHasShip = opponent && Object.values(opponent.ships).flat().includes(cell);

      if (isHit) {
        className += ' hit';
      } else if (isMiss) {
        className += ' miss';
      } else if (showAllShips && opponentHasShip) {
        // Show remaining ships that weren't hit at end of game
        className += ' ship revealed';
      } else if (gameState.phase === 'battle' && gameState.currentTurn === playerId) {
        className += ' targetable';
      }
    }

    return (
      <div
        key={cell}
        className={className}
        onClick={() => onCellClick(cell)}
      >
        {content}
      </div>
    );
  };

  const renderGrid = () => {
    const cells = [];

    cells.push(<div key="empty" className="grid-header"></div>);
    for (let col = 1; col <= 12; col++) {
      cells.push(
        <div key={`col-${col}`} className="grid-header">
          {String.fromCharCode(64 + col)}
        </div>
      );
    }

    for (let row = 1; row <= 12; row++) {
      cells.push(
        <div key={`row-${row}`} className="grid-header">
          {row}
        </div>
      );
      
      for (let col = 1; col <= 12; col++) {
        cells.push(renderCell(row, col));
      }
    }

    return cells;
  };

  // Add opponent-board class for radar effect during battle when it's your turn
  const isActiveOpponentBoard = !isOwnBoard &&
    gameState.phase === 'battle' &&
    gameState.currentTurn === playerId;

  return (
    <div className={`game-board ${isActiveOpponentBoard ? 'opponent-board' : ''}`}>
      {renderGrid()}
    </div>
  );
}

export default GameBoard;